import React from "react";
import "./style.css";
import canadaImage from "../../assets/canada.webp";
import Particles from "../Particles/Particles";
import university1 from "../../assets/university-logos/canada/Laurentian_University.webp";
import university2 from "../../assets/university-logos/canada/MCGill_Univerisity.webp";
import university3 from "../../assets/university-logos/canada/McMaster_University.webp";
import university4 from "../../assets/university-logos/canada/Simon_Fraser_University.webp";
import university5 from "../../assets/university-logos/canada/Univeristy_of_Calgary.webp";
import university6 from "../../assets/university-logos/canada/University_of_Alberta.webp";
import university7 from "../../assets/university-logos/canada/University_of_Ottawa.webp";
import university8 from "../../assets/university-logos/canada/Western_University_Canada.webp";
import university9 from "../../assets/university-logos/canada/York_University.webp";

const universityList = [
  { id: Math.random(), image: university1 },
  { id: Math.random(), image: university2 },
  { id: Math.random(), image: university3 },
  { id: Math.random(), image: university4 },
  { id: Math.random(), image: university5 },
  { id: Math.random(), image: university6 },
  { id: Math.random(), image: university7 },
  { id: Math.random(), image: university8 },
  { id: Math.random(), image: university9 },
];

const Canada = () => {
  return (
    <>
      <Particles
        title="Study in Canada"
        subTitle="From Application to Arrival – We've Got You Covered"
        image={canadaImage}
      />
      <div className="short-description container">
        <h1 className="text-left">Study in Canada</h1>
        <p className="text-justify">
          Canada stands as a premier destination for students worldwide,
          celebrated for its inclusive atmosphere, rich cultural diversity, and
          esteemed academic institutions. Surrounded by stunning natural beauty,
          the country provides a dynamic and welcoming environment that nurtures
          both academic achievement and personal development. Renowned for its
          commitment to education and research excellence, Canada attracts
          students globally to its top-tier universities and colleges. Whether
          you're drawn to vibrant urban centers or the serenity of nature,
          Canada offers a multitude of study locations to match every interest
          and preference. As you begin your educational path in Canada, you'll
          encounter abundant opportunities for intellectual discovery, cultural
          exchange, and professional growth. From pioneering research projects
          to hands-on learning experiences, Canada offers a platform for
          students to broaden their perspectives and reach their full potential.
          <br /> <br />
          <strong>Educraft Education Network</strong> has proudly supported
          Nepali students in securing admissions and student visas for Canadian
          universities and colleges for many years. We are dedicated to helping
          students explore global academic opportunities and pursue their dreams
          of studying abroad. With the increasing trend of students seeking
          quality education and career advancement overseas, Canada has emerged
          as a top choice due to its excellent education system, diverse and
          inclusive society, and promising career prospects. At Educraft, we
          guide you through every step of the process — from selecting the ideal
          program and institution to preparing your application documents and
          managing your visa application. Our experienced team strives to make
          your journey to study in Canada as seamless, safe, and successful as
          possible.
        </p>
      </div>

      <div className="why-study container">
        <h1 className="text-left">Why study in Canada? </h1>
        <p className="text-left">
          Canada has become a leading destination for international students
          worldwide. Here’s why you should consider Canada for your higher
          education:
        </p>
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active"
              id="first-tab"
              data-bs-toggle="tab"
              data-bs-target="#first"
              type="button"
              role="tab"
              aria-controls="first"
              aria-selected="true"
            >
              Academic Excellence
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="second-tab"
              data-bs-toggle="tab"
              data-bs-target="#second"
              type="button"
              role="tab"
              aria-controls="second"
              aria-selected="false"
            >
              Diverse Programs
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="third-tab"
              data-bs-toggle="tab"
              data-bs-target="#third"
              type="button"
              role="tab"
              aria-controls="third"
              aria-selected="false"
            >
              Global Recognition
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-link"
              id="fourth-tab"
              data-bs-toggle="tab"
              data-bs-target="#fourth"
              type="button"
              role="tab"
              aria-controls="fourth"
              aria-selected="false"
            >
              Welcoming & Safe Space
            </button>
          </li>
        </ul>
        <div className="tab-content" id="myTabContent">
          <div
            className="tab-pane show active"
            id="first"
            role="tabpanel"
            aria-labelledby="first-tab"
          >
            <h6>
              Canadian universities consistently rank among the world’s most
              prestigious institutions, known for their rigorous academic
              standards and commitment to excellence. These institutions offer
              high-quality education delivered by distinguished faculty members
              who are leaders in their fields. Students benefit from innovative
              teaching methods, access to state-of-the-art facilities, and
              opportunities to participate in groundbreaking research projects
              that contribute to advancements across various disciplines.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="second"
            role="tabpanel"
            aria-labelledby="second-tab"
          >
            <h6>
              Canada offers an extensive selection of academic programs across
              diverse fields, allowing students to customize their education to
              align perfectly with their interests and career goals. Whether
              your passion lies in engineering, health sciences, business,
              technology, arts, or social sciences, Canadian institutions
              provide flexible study options — including majors, minors, and
              interdisciplinary courses — to help you build a comprehensive and
              personalized academic experience.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="third"
            role="tabpanel"
            aria-labelledby="third-tab"
          >
            <h6>
              Degrees earned from Canadian universities are respected and valued
              worldwide, giving graduates a competitive edge in the global job
              market. This strong international recognition enables students to
              pursue career opportunities not only within Canada but also across
              numerous countries and industries. Many programs incorporate
              practical work placements or co-op experiences, equipping students
              with real-world skills and professional networks that further
              enhance their employability.
            </h6>
          </div>
          <div
            className="tab-pane"
            id="fourth"
            role="tabpanel"
            aria-labelledby="fourth-tab"
          >
            <h6>
              Canada is widely regarded as one of the safest countries in the
              world, with a reputation for being inclusive and multicultural.
              International students are warmly welcomed into communities known
              for their friendliness and cultural openness. This supportive
              atmosphere ensures students feel secure and valued, fostering a
              positive learning experience both on and off campus. Canadian
              society’s commitment to diversity and inclusion means that
              students from all backgrounds can thrive personally and
              academically.
            </h6>
          </div>
        </div>
      </div>

      <div className="university-partners container">
        <h1 className="text-left">Our University Partner in Canada</h1>
        <div className="row">
          {universityList?.map((list) => (
            <div key={list.id} className="col-6 col-md-4 col-lg-3 p-2">
              <div className="partner-box">
                <img src={list.image} alt="university logo" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Canada;
